import { PlaceholderView } from 'src/components';
import { useLocation } from 'react-router-dom';

const SECTION_LABELS: Record<string, string> = {
  conversations: 'Rozmowy o jodze',
  podcast: 'Podcast',
  ebooks: 'Ebooki',
};

export const KnowledgePage: React.FC = () => {
  const { pathname } = useLocation();
  const section = pathname.split('/').pop() ?? '';
  const label = SECTION_LABELS[section] ?? 'Baza wiedzy';

  return <PlaceholderView title={label} />;
};
